import React from 'react';
import { PartnerDetailsContainer } from '@/modules/Partners';

const UsersList = (): JSX.Element => <PartnerDetailsContainer />;

export default UsersList;
